import { type DatasetsQuery } from "@decentriq/graphql/dist/types";
import {
  faFile as falFile,
  faTable as falTable,
  type IconDefinition,
} from "@fortawesome/pro-light-svg-icons";
import { type DataType } from "models";

export type DatasetColumnDef = Omit<Dataset, "__typename">;

export type Dataset = DatasetsQuery["datasets"]["nodes"][number] & {
  type: DataType | null;
  hasKeychainItem: boolean;
};

export const datasetTypeDisplayMap: Record<
  DataType,
  { icon: IconDefinition; label: string }
> = {
  table: {
    icon: falTable,
    label: "Table",
  },
  unstructured: {
    icon: falFile,
    label: "File",
  },
};
